import {
	RESET_STATE,
	SET_AUTOPARK_TRANSPORT_INFO,
	SET_IS_AUTOPARK_TRANSPORT_INFO_LOADING,
	SET_TRANSPORT_TYPES_LIST,
	SET_IS_TRANSPORT_TYPES_LIST_LOADING,
	SET_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST,
	SET_IS_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST_LOADING,
	SET_ADDRESSES_LIST,
	SET_IS_ADDRESSES_LIST_LOADING,
	SET_IS_AUTOPARK_TRANSPORT_CREATING,
	SET_IS_AUTOPARK_TRANSPORT_UPDATING,
	SET_IS_AUTOPARK_TRANSPORT_DELETING,
} from './actions';

export const initialState = {
	autoparkTransportInfo: null,
	isAutoparkTransportInfoLoading: false,
	transportTypesList: [],
	isTransportTypesListLoading: false,
	autoparkTransportTariffTypesList: [],
	isAutoparkTransportTariffTypesListLoading: false,
	addressesList: [],
	isAddressesListLoading: false,
	isAutoparkTransportCreating: false,
	isAutoparkTransportUpdating: false,
	isAutoparkTransportDeleting: false,
};

const autoparkTransportModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_AUTOPARK_TRANSPORT_INFO:
			return {
				...state,
				autoparkTransportInfo: payload,
			};
		case SET_IS_AUTOPARK_TRANSPORT_INFO_LOADING:
			return {
				...state,
				isAutoparkTransportInfoLoading: payload,
			};
		case SET_TRANSPORT_TYPES_LIST:
			return {
				...state,
				transportTypesList: payload,
			};
		case SET_IS_TRANSPORT_TYPES_LIST_LOADING:
			return {
				...state,
				isTransportTypesListLoading: payload,
			};
		case SET_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST:
			return {
				...state,
				autoparkTransportTariffTypesList: payload,
			};
		case SET_IS_AUTOPARK_TRANSPORT_TARIFF_TYPES_LIST_LOADING:
			return {
				...state,
				isAutoparkTransportTariffTypesListLoading: payload,
			};
		case SET_ADDRESSES_LIST:
			return {
				...state,
				addressesList: payload,
			};
		case SET_IS_ADDRESSES_LIST_LOADING:
			return {
				...state,
				isAddressesListLoading: payload,
			};
		case SET_IS_AUTOPARK_TRANSPORT_CREATING:
			return {
				...state,
				isAutoparkTransportCreating: payload,
			};
		case SET_IS_AUTOPARK_TRANSPORT_UPDATING:
			return {
				...state,
				isAutoparkTransportUpdating: payload,
			};
		case SET_IS_AUTOPARK_TRANSPORT_DELETING:
			return {
				...state,
				isAutoparkTransportDeleting: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default autoparkTransportModalReducer;
